import { render } from "./HomeOrders.vue?vue&type=template&id=59fd49f8&scoped=true"
import script from "./HomeOrders.vue?vue&type=script&lang=js"
export * from "./HomeOrders.vue?vue&type=script&lang=js"

import "./HomeOrders.vue?vue&type=style&index=0&id=59fd49f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fd49f8"]])

export default __exports__